/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { termsLink } from "../../constants";

const containerCSS = css`
    color: #999999;
    font-size: 13px;
    padding: 16px 0;
    margin-top: 0;

    p {
        font-size: inherit;
    }

    a {
        color: inherit;
    }
`;

function AtlasTerms() {
    return (
        <div css={containerCSS}>
            <p>
                Please note that while we endeavour to keep everything you read on our site up-to-date, we cannot
                guarantee the reliability of all information. By using this website you agree to our{" "}
                <a href={termsLink} target="_blank" rel="noopener noreferrer">
                    terms and conditions
                </a>
                .
            </p>
        </div>
    );
}

export default AtlasTerms;
